export default __webpack_public_path__ + "static/media/clown-face_1f921.b22e31e4.png";